/** @format */

const NotFound = (props) => <div className='main-box app__grid mt-5'>Not Found</div>;

export default NotFound;
